import { Divider } from 'antd'

export default function Interests() {
    return <>
        <h2>TECHNOLOGY</h2>
        <p>Artificial Intelligence (AI), Machine Learning, Deep Learning, Reinforcement Learning, Data Science and Analytics, Massive Open Online Course (MOOC), Human-Computer Interaction (HCI), User Interface & User Experience (UI/UX), Human-AI Interaction (HAI) Web & Mobile Application Development, Educational Technology</p>
        <Divider>THE ROOTS OF EDUCATION ARE BITTER, BUT THE FRUIT IS SWEET</Divider>
        <h2>ART AND SPORT</h2>
        <p>Street Dance, Performing Arts, Acting, Singing, Running, Basketball, Volleyball, Table Tennis</p>
        <Divider>NEVER GIVE UP</Divider>
        <h2>MUSIC</h2>
        <p>K-Ballad, K-Pop, Easy Listening, Rap/Hip-Hop, R&amp;B, Soundtracks</p>
        <Divider>DREAM DON'T WORK UNLESS YOU DO</Divider>
        <h2>OTHER</h2>
        <p>Photography, Watching Movies/Dramas</p>
    </>
}